import { Dispatch } from 'react';
import { createContext } from 'use-context-selector';
import { PayloadAction } from 'typesafe-actions';
import { BeneficiariesState, BeneficiariesContextActionTypes } from './types';
import { defaultBeneficiariesState } from './defaultState';

const BeneficiariesContext = createContext<Partial<BeneficiariesState>>(defaultBeneficiariesState);
const BeneficiariesDispatchContext = createContext<
  Dispatch<PayloadAction<BeneficiariesContextActionTypes, any>> | undefined
>(undefined);

export { BeneficiariesContext, BeneficiariesDispatchContext };
